import { RemoteDeveloper } from "../../../../data/usecases/developer/remote-developer";
import { Developer } from "../../../../domain/models/developer.model";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteDeveloper = (): Developer =>
  new RemoteDeveloper("/developers", makeAxiosHttpClient(), settings.API_URL);
